import { UtilService } from './../../../../shared/services/util/util.service';
import { Component, OnInit, Input, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { json } from './causes-object';
@Component({
  selector: 'app-causes-list',
  templateUrl: './causes-list.component.html',
  styleUrls: ['./causes-list.component.scss']
})
export class CausesListComponent implements OnInit {
  causes: { outer: boolean, class: string, link: string, text: string, params?: any }[] = json;
  @Input('defaultImg') defaultImg: string;
  lazyLoadImage;
  isMobile: any;
  show = false;
  moreBtn = 'View More';

  constructor(
    private utilService: UtilService,
    private actRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    this.lazyLoadImage = this.defaultImg ? this.defaultImg : '/assets/images/homepage/causes-bg.png';
  }

  toggle() {
    this.show = !this.show;
    this.moreBtn = this.show ? 'View Less' : 'View More';
  }
}
